export default Object.freeze({
  DocumentData: 'DocumentData',
  Environment: 'Environment',
  Export: 'Export',
  NavigationData: 'NavigationData',
  ProductData: 'ProductData',
});
